"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  status: 200,
  msg: "ok",
  data: {
    list: [{
      id: 1,
      cate_id: 4,
      type: 0,
      name: "首页",
      url: "/pages/home/index",
      param: " ",
      example: "/pages/home/index",
      status: 1,
      sort: 0,
      add_time: 1626837579
    }]
  }
};